var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.loading)?_c('v-row',{attrs:{"justify":"center"}},[_c('Loading')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }